const cleanText = text => {
  if (!text || typeof text !== "string") return "";

  let cleaned = text;

  // Step 1: Remove Markdown code blocks (``` or ~~~)
  cleaned = cleaned.replace(/```[\s\S]*?```/g, ""); // Fenced code blocks (```)
  cleaned = cleaned.replace(/~~~[\s\S]*?~~~/g, ""); // Fenced code blocks (~~~)

  // Step 2: Remove inline code (`code`)
  cleaned = cleaned.replace(/`[^`]+`/g, match => match.slice(1, -1)); // Keep content, remove backticks

  // Step 3: Remove Markdown headers (#, ##, etc.)
  cleaned = cleaned.replace(/^\s*#+ .*$/gm, "");

  // Step 4: Remove Markdown links ([text](url))
  cleaned = cleaned.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1"); // Keep link text, remove URL

  // Step 5: Remove Markdown emphasis (*text*, **text**, _text_)
  cleaned = cleaned.replace(/[*_]{1,2}([^*_]+)[*_]{1,2}/g, "$1");

  // Step 6: Remove Markdown lists (-, *, 1., etc.)
  cleaned = cleaned.replace(/^\s*[-*+]\s+.*$/gm, "");
  cleaned = cleaned.replace(/^\s*\d+\.\s+.*$/gm, "");

  // Step 7: Remove emojis (Unicode ranges for common emojis)
  cleaned = cleaned.replace(
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
    ""
  );

  // Step 8: Remove HTML tags
  cleaned = cleaned.replace(/<[^>]+>/g, ""); // Remove all HTML tags

  // Step 9: Remove HTML entities (e.g., &, <, ')
  cleaned = cleaned.replace(/&[a-zA-Z0-9#]+;/g, "");

  // Step 10: Remove extra whitespace and newlines
  cleaned = cleaned
    .replace(/\n\s*\n/g, "\n")
    .replace(/\s+/g, " ")
    .trim();

  return cleaned;
};

// Helper function to convert base64 to Blob
const base64ToBlob = (base64, contentType) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

// const getHdVoiceByAvatarId = avatarID => {
//   console.log(`avatarID: ${avatarID}`);
//   switch (parseInt(avatarID)) {
//     case 1:
//       // Messi
//       return { languageCode: "es-US", voiceName: "Fenrir", speakingRate: 0.93 };
//     case 2:
//       // Ronaldo
//       return { languageCode: "es-ES", voiceName: "Orus", speakingRate: 1 };
//     case 3:
//       // Favre
//       return { languageCode: "en-US", voiceName: "Umbriel", speakingRate: 1 };
//     default:
//       // Isa
//       return { languageCode: "es-US", voiceName: "Despina", speakingRate: 0.98 };
//   }
// };

const createTTSAudioURL = async (text, hDVoice, onError = null) => {
  try {
    const apiKey = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY;
    console.log(
      `hDVoice.languageCode: ${hDVoice.languageCode}, hDVoice.voiceName: ${hDVoice.voiceName}`
    );
    if (!apiKey) {
      throw new Error("Google Cloud API key is missing. Please configure it.");
    }

    const response = await fetch(
      `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          input: { text: text },
          voice: {
            languageCode: hDVoice.languageCode,
            // name: "es-US-Chirp3-HD-Autonoe",
            name: `${hDVoice.languageCode}-Chirp3-HD-${hDVoice.voiceName}`,
          },
          // audioConfig: {
          //   audioEncoding: "MP3",
          // },
          audioConfig: {
            audioEncoding: "LINEAR16",
            speakingRate: hDVoice.speakingRate,
          },
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error details:", errorData);
      throw new Error(
        `HTTP error! status: ${response.status}, message: ${
          errorData.error?.message || "Unknown error"
        }`
      );
    }

    const data = await response.json();
    if (!data.audioContent) {
      throw new Error("No audio content returned from API");
    }

    const audioBlob = base64ToBlob(data.audioContent, "audio/mp3");
    return URL.createObjectURL(audioBlob);
  } catch (error) {
    console.error("Error synthesizing speech:", error);
    onError?.(error.message);
  }
};

export async function convertTextToSpeech(text, voiceConfig, onError = null) {
  // Clean the text before creating an audio URL
  const cleanedText = cleanText(text);
  if (!cleanedText) {
    onError?.("No valid text after cleaning");
    return;
  }
  // Return the audio URL
  return createTTSAudioURL(cleanedText, voiceConfig);
}
